import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 6 6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      d: "M5.84.16a.555.555 0 0 0-.78 0L3 2.222.947.16a.555.555 0 0 0-.78 0 .556.556 0 0 0 0 .781L2.22 3.003.16 5.06a.556.556 0 0 0 0 .78C.267 5.948.407 6 .553 6a.55.55 0 0 0 .394-.16L3 3.784 5.053 5.84c.107.107.247.16.394.16a.56.56 0 0 0 .393-.16.556.556 0 0 0 0-.781L3.78 3.003 5.833.948c.22-.22.22-.568.007-.788"
    }, null, -1)
  ]))]))
}
export default { render: render }